import { Provider } from 'react-redux';
import store from '../../../store';
import PageHeader from '../../PageHeader';
import PageStaticSection from '../../PageStaticSection';
import PageTitle from '../../PageTitle';
import NotificationsList from '../NotificationsList';
import NotificationsMarkAllAsReadButton from '../NotificationsMarkAllAsReadButton';
import styles from './style.m.less';

export default function NotificationsPage() {
    const title = 'Your Notifications';
    return (
        <Provider store={store}>
            <>
                <PageTitle title={title} />
                <PageHeader title={title} />
                <PageStaticSection>
                    <div className={styles.page_actions}>
                        <NotificationsMarkAllAsReadButton />
                    </div>
                    <div className={styles.list}>
                        <NotificationsList />
                    </div>
                </PageStaticSection>
            </>
        </Provider>
    );
}
